window.onload = function() {
  let productFormAll = document.querySelectorAll(".product-block .product-card-form");
    // theme.cardSwatches(productFormAll)
  // let colorFilterOptions = document.querySelectorAll(".gf-option-value");
  // colorFilterOptions.forEach((colorOption) => {
  //   colorOption.innerHTML = '';
  //   let color =  colorOption.closest('button').getAttribute('data-fvalue').split('-')[1];
  //   colorOption.style.backgroundColor = color;
  //   // console.log(color)
  // })
    
  
}
document.addEventListener("DOMContentLoaded", () => {
  let productFormAll = document.querySelectorAll(".product-card-form");
  theme.cardSwatches(productFormAll);
});
let count = 0;

theme.cardSwatches =  function  (cards) {
  const SHOP_URL = "https://" + Shopify.shop;
  // Remember to switch to your dev store token when working locally
  const ACCESS_TOKEN = "c0fcf6de93090cdc393cf7ea35406da8";
  // const productFormAll = document.querySelectorAll(".product-card-form");
  const productFormAll = cards;
productFormAll.forEach((productForm) => {
    const allVariants = JSON.parse(
    productForm.getAttribute("data-all-variant-ids")
  );
  let variantId = productForm.getAttribute("data-variant-id");
  let productId = productForm.getAttribute("data-product-id");
  let productHandle = productForm.getAttribute("data-product-handle");
  let publishedAt = productForm.getAttribute("data-published-at");
  let variantQuantity = 1;
  let checkoutUrl = null;
  let preorderAppSettings = null;

  const productSwitcher = {
    init: function () {
      this.changeElColors(productForm.getAttribute("data-color"));
      this.events();

      $(window).bind("popstate", function () {
        window.location.href = window.location.href;
      });

      let variantGid = "gid://shopify/ProductVariant/" + variantId;

      this.getCheckoutUrl(variantGid);

      if (productId == "1475486154835") {
        this.fetchPreorderAppSettings();
      }

      this.showSelectSizeMessage();
    },

    showSelectSizeMessage() {
      let sizeChecked = this.checkIfSizeSelected();
      if (!sizeChecked) {
        const selectSizeMessage = document.getElementById(
          "select-size-message"
        );
        if (selectSizeMessage) {
          selectSizeMessage.textContent = allVariants
            ? "Please select the product size and length!"
            : "Please select the product size!";
          selectSizeMessage.classList.add("hidden");
        }
        this.disabledCartButton(true);
      }
    },

    checkIfSizeSelected() {
      const checkedButton = productForm.querySelector(
        'input[name="options[Size]"]:checked'
      );
      return checkedButton;
    },

    isLengthAndSizeSelected() {
      const isSizeSelected = productForm.querySelector(
        'input[name="option-size"]:checked'
      );
      const isLengthSelected = productForm.querySelector(
        'input[name="option-length"]:checked'
      );
      return isSizeSelected && isLengthSelected;
    },

    setVariantId() {
      let self = this;
      const selectedSize = document.querySelector(
        'input[name="option-size"]:checked'
      )?.value;
      const selectedLength = document.querySelector(
        'input[name="option-length"]:checked'
      )?.value;
      const variant = allVariants.find(
        (variant) =>
          variant.options?.includes(selectedSize) &&
          variant.options?.includes(selectedLength)
      );
      const priceElement = document.querySelector(".current-price.theme-money");

      if (variantId) {
        self.switchFlareLengthDescription(variantId, true);
      }

      variantId = variant.id;
      productForm.setAttribute("data-variant-id", variantId);

      if (priceElement) {
        priceElement.textContent = theme.Shopify.formatMoney(
          variant.price,
          theme.money_format
        );
      }

      self.switchFlareLengthDescription(variantId);
      const selectSizeMessage = document.getElementById("select-size-message");
      const comingSoon = document.getElementById("coming-soon");
      const form = document.querySelector(".product-detail__form__action");

      if (!variant.available) {
        self.disabledCartButton(true);

        if (selectSizeMessage) {
          selectSizeMessage.textContent = "Selected variant is not available";
        }

        if (comingSoon) {
          comingSoon.classList.remove("hidden");
          comingSoon.style.display = "block";
        }

        form?.classList.add("hidden");
      } else {
        if (comingSoon) {
          comingSoon.classList.add("hidden");
          comingSoon.style.display = "none";
        }
        form?.classList.remove("hidden");
      }
    },

    switchFlareLengthDescription(id, shouldHide = false) {
      let flareLengthDescription = document.getElementById(
        `variant-length-${id}`
      );

      if (!flareLengthDescription) {
        return;
      }

      if (shouldHide) {
        return flareLengthDescription.classList.add("hidden");
      }

      flareLengthDescription.classList.remove("hidden");
    },

    disabledCartButton(state) {
      const message = document.getElementById("select-size-message");
      const addToCart = document.querySelector(".addToCart");
      const buyItNowButton = document.querySelector(".buyItNowButton");
      if (state) {
        addToCart?.classList.add("disabled-button");
        buyItNowButton?.classList.add("disabled-button");
      } else {
        message?.classList.add("hidden");
        addToCart?.classList.remove("disabled-button");
        buyItNowButton?.classList.remove("disabled-button");
      }

      const checkForDynamicButton = setInterval(() => {
        const paymentButton = document.querySelector(".shopify-payment-button");
        if (paymentButton) {
          if (state) {
            paymentButton.classList.add("disabled-button");
          } else {
            paymentButton.classList.remove("disabled-button");
          }
          clearInterval(checkForDynamicButton);
        }
      }, 500);

      setTimeout(() => {
        clearInterval(checkForDynamicButton);
      }, 4000);
    },

    async subscribeToList(email, variantId, productId) {
      fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
        headers: {
          accept: "application/json, text/plain, */*",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams({
          a: "RtsfBd",
          email: email,
          platform: "shopify",
          variant: variantId,
          product: productId,
        }),
        method: "POST",
      })
        .then((response) => {
          if (response.status == 200) {
            document.querySelector("#subscriber-email").value = "";
            document.querySelector(".klaviyo-success").style.display = "block";
            MicroModal.close("modal-1");
            setTimeout(() => {
              document.querySelector(".klaviyo-success").style.display = "none";
            }, 5000);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // Remember to switch to your dev store url and domain when working locally
    async fetchPreorderAppSettings() {
      const response = await axios({
        method: "POST",
        url: "https://preorder-now.herokuapp.com/widget/settings",
        data: {
          shopify_domain: Shopify.shop,
          product_ids: productId,
          //   url: `https://www.davisactive.com/products/${productHandle}`,
          url: `${SHOP_URL}/products/${productHandle}`,
        },
      }).then((data) => {
        preorderAppSettings = data.data;
      });
    },

    getProduct: function (productId, context = '') {
      const query = `query SpecificProduct($id: ID!) {
          product(id: $id) {
              id
              title
              description
              handle
              totalInventory
              options(first: 10) {
                  id
                  name
                  values
              }
              metafields(identifiers: [{namespace: "custom", key: "coming_soon"},{namespace: "custom", key: "available_for_preorder"},{namespace: "custom", key: "related_products"}]) {
                  namespace
                  key
                  value
                }
              variants(first: 10) {
                  nodes {
                    id
                    price {
                      amount
                      currencyCode
                    }
                    title
                    quantityAvailable
                    metafields(identifiers: [{namespace: "custom", key: "length_description"}]) {
                      namespace
                      key
                      value
                    }
                    selectedOptions {
                      value
                      name
                    }
                  }
              }
              media(first: 2) {
                edges {
                  node {
                    previewImage {
                      id
                      src
                    }
                  }
                }
              }
            }
        }`;

      const params = {
        query: query,
        variables: { id: productId },
      };

      const optionsQuery = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
        },
        body: JSON.stringify(params),
      };

      fetch(SHOP_URL + `/api/graphql`, optionsQuery)
        .then((res) => res.json())
        .then((response) => {
          const {
            data: { product },
          } = response;

          const price = product.variants?.nodes[0]?.price.amount * 100;
          if (allVariants) {
            this.updateAllVariants(product.variants?.nodes);
          }
          
          this.updateProductInfo(
            product.id,
            product.title,
            product.description,
            product.variants,
            price,
            product.variants.nodes[0].id,
            product.media.edges,
            product.handle,
            product.totalInventory,
            product.metafields,
            product.options,
            context
          );

          theme.OptionManager.updatePrice(
            {
              available: product.totalInventory > 0,
              compare_at_price: 0,
              price: price,
            },
            $(".product-area")
          );

          this.getCheckoutUrl(variantId);
        })
        .catch((error) => {
          console.error("Error fetching product:", error);
        });
    },

    updateAllVariants(variants = []) {
      variants.forEach((variant, index) => {
        allVariants[index] = {
          id: parseInt(variant.id.replace("gid://shopify/ProductVariant/", "")),
          available: variant.quantityAvailable > 0,
          options: variant.selectedOptions.map((option) => option.value),
          price: variant.price.amount * 100,
          title: variant.title,
        };
      });
    },

    getCheckoutUrl(variantId) {
      const query = `mutation {
            checkoutCreate(input: {
              lineItems: [{ variantId: "${variantId}", quantity: 1 }]
            }) {
              checkout {
                id
                webUrl
              }
              userErrors {
                field
                message
              }
            }
          }`;
      const params = {
        query: query,
      };

      const optionsQuery = {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN,
        },
        body: JSON.stringify(params),
      };
// will be uncomented maybe
      // fetch(SHOP_URL + `/api/graphql`, optionsQuery)
      //   .then((res) => res.json())
      //   .then((response) => {
      //     const {
      //       data: {
      //         checkoutCreate: { checkout },
      //       },
      //     } = response;

      //     checkoutUrl = checkout.webUrl;
      //   });
    },

    updateProductInfo(
      id,
      title,
      description,
      variants,
      price,
      vId,
      images,
      handle,
      totalInventory,
      metafields,
      options,
      context = ''
    ) {
      let comingSoon = metafields.find(
        (metafield) => metafield && metafield.key === "coming_soon"
      );
      const pLink = context.querySelector('[data-cc-quick-buy]');
      const pCardLink = context.querySelector('[data-cc-animate-click]');
      const pTitle = context.querySelector(".title");
      const pDescription = document.querySelector(".cc-tabs__tab__panel");
      const pPrice = context.querySelector(".price");

      const pImage = document.querySelector(".product__image");
      const slideImage = document.querySelector(
        ".product-slideshow__slide-image"
      );
      // const form = document.querySelector(".product-card-form");
      const form = context.querySelector(".product-card-form");
      const sizesRow = document.querySelector(".config__row");
      const productForm = document.getElementById("productBuyOptions");
      const addToCart = document.querySelector(".addToCart");
      const soldoutMessage = document.querySelector(".coming-soon");
      if (totalInventory <= 0) {
        if (productForm) {
          productForm.style.display = "none";
          productForm.classList.remove("show-addtocart");
        }
        // if(soldoutMessage){
        //   soldoutMessage.style.display = "block";
        //   if(comingSoon && comingSoon.node.value == "true"){

        //   }else{
        //     soldoutMessage.textContent = "This product is sold out";
        //   }
        // }
        if (addToCart) {
          addToCart.disabled = true;
        }
      } else {
        document
          .querySelector(".product-detail__form__action")
          ?.classList.add("show-addtocart");

        if (productForm) {
          productForm.style.display = "block";
        }

        if (soldoutMessage) {
          soldoutMessage.style.display = "none";
        }

        if (addToCart) {
          addToCart.disabled = false;
          addToCart.textContent = "Add To Cart";
        }
      }

      if (pTitle) {
        pTitle.textContent = title;
      }
      
       if (pCardLink) {
        pCardLink.href = `https://www.davisactive.com/products/${handle}`;
      }
      if (pLink) {
        pLink.href = `https://www.davisactive.com/products/${handle}`;
      }
        if (pPrice) {
          pPrice.innerHTML = theme.Shopify.formatMoney(
          price,
          theme.money_format
        );
      }

      if (pDescription) {
        pDescription.textContent = description;
      }

      const gid = id;
      const productId = gid.replace("gid://shopify/Product/", "");
      const variantGid = vId;
      variantId = variantGid.replace("gid://shopify/ProductVariant/", "");
      form.id = `product_form_${productId}`;
      this.addImages(images, form.closest('.product-block'));

      if (sizesRow) {
        sizesRow.innerHTML = "";
      }

      let select = document.querySelector(".modal-variant-select");

      if (select) {
        select.innerHTML = "";
      }

      if (options.length && this.hasLengthOption(options)) {
        options.forEach((option) => {
          const optionRow = document.getElementById(
            `config__row-${option.name.toLowerCase()}`
          );
          optionRow.innerHTML = null;

          option.values.forEach((name) => {
            let label = this.createLabel(name);
            let span = this.createLabelText(name);
            let input = this.createOptionInput(name, option.name);

            label.append(input);
            label.append(span);
            optionRow.append(label);
          });
        });

        let lengthDescriptionAccordion = document.querySelector(
          ".cc-tabs__tab.length-description"
        );
        lengthDescriptionAccordion.innerHTML = null;

        variants.nodes.forEach((variant) => {
          let id = parseInt(
            variant.id.replace("gid://shopify/ProductVariant/", "")
          );
          let renderedHTML = "-";

          if (select) {
            let selectOption = document.createElement("option");
            selectOption.textContent = variant.title;
            let vId = id;
            selectOption.value = vId;
            select.append(selectOption);
          }

          let lengthMetafield = variant.metafields.find(
            (metafield) => metafield && metafield.key === "length_description"
          );

          if (lengthMetafield) {
            // Render the length metafield as HTML
            renderedHTML = this.renderRichTextMetafield(
              JSON.parse(lengthMetafield.value)
            );
          }

          this.createLengthDescriptionTab(
            id,
            renderedHTML,
            lengthDescriptionAccordion
          );
        });
      } else {
        variants.nodes.forEach((element) => {
          const quantity = element.quantityAvailable;
          if (element.title == "Default Title") {
            return;
          }

          if (select) {
            let selectOption = document.createElement("option");
            selectOption.textContent = element.title;
            let vId = element.id.replace("gid://shopify/ProductVariant/", "");
            selectOption.value = vId;
            select.append(selectOption);
          }

          let elementId = element.id.replace(
            "gid://shopify/ProductVariant/",
            ""
          );

          let label = document.createElement("label");
          label.setAttribute("for", "options-" + element.title);
          label.classList.add("config__label");

          let input = document.createElement("input");
          input.setAttribute("id", "options-" + element.title);
          input.setAttribute("type", "radio");
          input.setAttribute("name", "options[Size]");
          input.setAttribute("data-preorder", "false");
          input.setAttribute("data-q", element.quantityAvailable);
          input.value = element.title;
          input.setAttribute("data-id", elementId);
          input.classList.add("config__size");

          input.addEventListener("click", function () {
            variantId = input.getAttribute("data-id");
          });

          label.append(input);

          let span = document.createElement("span");
          span.classList.add("config__size-text");
          span.textContent = element.title;

          label.append(span);
          if (sizesRow) {
            sizesRow.append(label);
          }
        });
      }

      this.disabledCartButton(true);

      // window.history.pushState("", title, "/products/" + handle);
    },

    createLabel(name) {
      let label = document.createElement("label");
      label.setAttribute("for", `options-${name}`);
      label.classList.add("config__label");

      return label;
    },

    createLabelText(name) {
      let span = document.createElement("span");
      span.classList.add("config__size-text");
      span.textContent = name;

      return span;
    },

    createOptionInput(name, optionName) {
      let input = document.createElement("input");
      input.setAttribute("id", `options-${name}`);
      input.setAttribute("type", "radio");
      input.setAttribute("name", `option-${optionName.toLowerCase()}`);
      input.value = name;
      input.classList.add("config__size");

      if (optionName.toLowerCase() === "length") {
        input.setAttribute("style", "border-radius: 4px; width: 80px;");
      }

      return input;
    },

    hasLengthOption(options = []) {
      let option = options.find((option) =>
        option.name.toLowerCase().includes("length")
      );

      if (option) {
        return true;
      }

      return false;
    },

    createLengthDescriptionTab(id, renderedHtml, rootElement) {
      // Create the outer div element
      const outerDiv = document.createElement("div");
      outerDiv.id = `variant-length-${id}`;
      outerDiv.className = "hidden";

      // Create the anchor element
      const anchorElement = document.createElement("a");
      anchorElement.href = "#";
      anchorElement.className = "cc-tabs__accordion__header";
      anchorElement.role = "tab";
      anchorElement.setAttribute("aria-selected", "false");
      anchorElement.setAttribute("aria-controls", `product-tab-panel_${id}`);
      anchorElement.setAttribute("data-cc-toggle-panel", `_${id}`);
      anchorElement.innerText = "Description";

      // Create the inner div element for the tab panel
      const innerDiv = document.createElement("div");
      innerDiv.className = "cc-tabs__tab__panel rte";
      innerDiv.setAttribute("hidden", "");
      innerDiv.role = "tab";
      innerDiv.id = `product-tab-panel_${id}`;
      innerDiv.setAttribute("aria-labelledby", `product-tab-panel_${id}`);

      // Create the inner div element for the variant length description
      const variantLengthDiv = document.createElement("div");
      variantLengthDiv.id = `variant-length-description-${id}`;
      variantLengthDiv.setAttribute("data-id", id);
      variantLengthDiv.innerHTML = renderedHtml;

      // Append the elements to build the desired HTML structure
      innerDiv.appendChild(variantLengthDiv);
      outerDiv.appendChild(anchorElement);
      outerDiv.appendChild(innerDiv);

      // Append the outer div to the parent element
      rootElement.appendChild(outerDiv);
    },

    // Function to recursively render the rich text metafield object as HTML
    renderRichTextMetafield(node) {
      if (node.type === "root") {
        return this.renderChildren(node.children);
      } else if (node.type === "paragraph") {
        return `<p>${this.renderChildren(node.children)}</p>`;
      } else if (node.type === "text") {
        return node.value;
      } else {
        return "";
      }
    },

    // Function to render the children of a metafield object
    renderChildren(children) {
      return children
        .map((child) => this.renderRichTextMetafield(child))
        .join("");
    },

    events: function () {
      let self = this;

      productForm.addEventListener("click", function (e) {
        if (
          e.target.name === "option-size" ||
          e.target.name === "option-length"
        ) {
          if (self.isLengthAndSizeSelected()) {
            self.disabledCartButton(false);
            self.setVariantId();
          }
          return;
        }
        
        if (allVariants && !self.isLengthAndSizeSelected()) {
          document
            .getElementById("select-size-message")
            ?.classList.remove("hidden");
          return;
        }

        // if (e.target.classList.contains("product-detail__form__action")) {
        //   let sizeChecked = self.checkIfSizeSelected();
        //   if (!sizeChecked) {
        //     const selectSizeMessage = document.getElementById(
        //       "select-size-message"
        //     );
        //     selectSizeMessage.classList.remove("hidden");
        //   }
        // }

        // if (e.target.classList.contains("config__size")) {
        //   let sizeChecked = self.checkIfSizeSelected();
        //   if (!sizeChecked) {
        //     self.disabledCartButton(true);
        //   } else {
        //     self.disabledCartButton(false);
        //   }
        //   variantId = e.target.getAttribute("data-id");

        //   variantQuantity = e.target.getAttribute("data-q");
        //   var preorder = e.target.getAttribute("data-preorder");
        //   self.checkPreorder(variantQuantity, preorder, variantId);
        //   const form = document
        //     .querySelector(".product-detail__form")
        //     .querySelector("form");

        //   form.setAttribute("data-variant-id", variantId);
        //   const paymentButton = document.querySelector(
        //     ".shopify-payment-button"
        //   );
        //   if (paymentButton) {
        //     paymentButton.innerHTML = "";
        //   }
        //   theme.initShopifyPaymentButtons($(".product-form"));
        // }
      });

      // var showModalButton = document.querySelector("#show-modal");
      // if (showModalButton) {
      //   showModalButton.addEventListener("click", function (e) {
      //     var options = document.querySelectorAll(".config__size");

      //     if (allVariants) {
      //       allVariants.forEach((variant) => {
      //         let variantSelect = document.querySelector(
      //           ".modal-variant-select"
      //         );
      //         let text = "Select";

      //         if (variantSelect) {
      //           variantSelect.value = variantId;
      //           text = variantSelect.options[variantSelect.selectedIndex].text;
      //         }

      //         document
      //           .querySelector(".pretty-select")
      //           .querySelector(".value").textContent = text;
      //       });
      //     } else {
      //       options.forEach((el) => {
      //         if (el.checked) {
      //           document.querySelector(".modal-variant-select").value =
      //             el.getAttribute("data-id");
      //           var sel = document.querySelector(".modal-variant-select");
      //           var text = sel.options[sel.selectedIndex].text;
      //           document
      //             .querySelector(".pretty-select")
      //             .querySelector(".value").textContent = text;
      //         }
      //       });
      //     }
      //     MicroModal.show("modal-1");
      //   });
      // }

      // var klaviyoPost = document.querySelector("#klaviyo-post");
      // if (klaviyoPost) {
      //   klaviyoPost.addEventListener("click", function (e) {
      //     var subscriberEmail =
      //       document.querySelector("#subscriber-email").value;
      //     var productId = document
      //       .querySelector(".product-form")
      //       .getAttribute("data-product-id");
      //     var productVariantId = document.querySelector(
      //       ".modal-variant-select"
      //     ).value;
      //     e.preventDefault();
      //     self.subscribeToList(subscriberEmail, productVariantId, productId);
      //   });
      // }

      var optionButtons = document.querySelectorAll(".color-option-button");
      optionButtons.forEach((element) => {
        element.addEventListener("click", function (e) {
          e.preventDefault();
          self.toggleActive(optionButtons, element);
          const color = element.getAttribute("data-color");
          const productId = element.getAttribute("data-id");
          self.changeElColors(color);
          
          self.getProduct("gid://shopify/Product/" + productId, this.closest('.product-block'));
        });
      });

      var optionSizeButtons = document.querySelectorAll(".option-button");
      optionSizeButtons.forEach((element) => {
        element.addEventListener("click", function (e) {
          e.preventDefault();
          self.toggleActive(optionSizeButtons, element);
          const productId = element.getAttribute("data-id");
          self.getProduct("gid://shopify/Product/" + productId, this.closest('.product-block'));
        });
      });

      const addToCart = document.querySelector(".addToCart");
      if (addToCart) {
        addToCart.addEventListener("click", function (e) {
          e.preventDefault();
          window.location = `/cart/add?id=${variantId}&quantity=1`;
        });
      }

      document.addEventListener("click", function (e) {
        const variantStoreId = "gid://shopify/ProductVariant/" + variantId;

        self.getCheckoutUrl(variantStoreId);

        if (e.target && e.target.classList.contains("buyItNowButton")) {
          e.preventDefault();
          if (checkoutUrl == null) {
            return;
          }
          window.location = checkoutUrl;
        }
      });
    },

    checkPreorder: function (quantity, preorder = true, variantId) {
      let isPreorderAvailable = true;
      if (preorderAppSettings != null) {
        var preorderSettings = preorderAppSettings.filter((item) => {
          return item.settings_type_id === variantId;
        })[0];
        let negativeLimit = preorderSettings.shopify_preorder_limit * -1;
        if (parseFloat(negativeLimit) > parseFloat(quantity)) {
          isPreorderAvailable = false;
        }
      }

      if (!preorder || !isPreorderAvailable) {
        return;
      }

      var soldOutMessage = document.querySelector(".coming-soon");

      var productForm = document.querySelector(".product-detail__form__action");
      var addToCart = document.querySelector(".addToCart");
      var buyItNow = document.querySelector(".buyItNowButton");
      var buyOptions = document.getElementById("productBuyOptions");
      var quantitWrapper = document.querySelector(".section-product-template");

      if (quantity > 0) {
        if (addToCart) {
          addToCart.textContent = "Add To Cart";
        }

        quantitWrapper.classList.add("hide-preorder");
        if (buyItNow) {
          buyItNow.style.display = "block";
        }
        // productForm.style.display = "flex";
        if (soldOutMessage) {
          soldOutMessage.style.display = "none";
        }
        if (buyOptions) {
          buyOptions.style.display = "block";
          buyOptions.classList.add("show-addtocart");
        }
      } else if (preorder == "true" && isPreorderAvailable) {
        // productForm.style.display = "flex";
        if (soldOutMessage) {
          soldOutMessage.style.display = "none";
        }
        if (addToCart) {
          addToCart.textContent = "Made to Order";
        }
        quantitWrapper.classList.remove("hide-preorder");

        if (buyItNow) {
          buyItNow.style.display = "none";
        }

        if (buyOptions) {
          buyOptions.style.display = "block";
          buyOptions.classList.add("show-addtocart");
        }
      } else {
        if (soldOutMessage) {
          soldOutMessage.style.display = "block";
        }

        if (buyOptions) {
          buyOptions.style.display = "none";
          buyOptions.classList.remove("show-addtocart");
        }
      }
    },

    addImages: function (images, context) {
      const imageFirst = context.querySelector(".image__first img.rimage__image");
      const imageSecond = context.querySelector(".image__second img.rimage__image");
      const imageFirstSrc = images[0].node.previewImage.src;
      const imageSecondSrc = images[1].node.previewImage.src;
      imageSecond.classList.remove("lazyloaded");
     
      imageFirst.setAttribute("srcset", imageFirstSrc);
      setTimeout(() => {
         imageSecond.setAttribute("srcset", imageSecondSrc);
        imageSecond.classList.add("lazyloaded");
      }, 600);
      // imageFirst.setAttribute("srcset", imageFirstSrc);
      // imageFirst.classList.add("lazyloaded");
      
      // imageSecond.setAttribute("srcset", imageSecondSrc);
      // console.log(imageFirst);
      // console.log(images[0].node.previewImage.src);
      // const themeImages = document.querySelector(".theme-images");
//       const themeImages = document.querySelector(".image-inner");
      
//       const slickTrack = document.querySelector(".slick-track");
//       const slickList = document.querySelector(".slick-list");
//       const swiperPagination = document.querySelector(".swiper-pagination");
//       window.scrollTo(0, 0);
//       // swiperPagination.innerHTML = "";
//       if (slickTrack) {
//         slickTrack.innerHTML = "";
//       }
//       // test
// console.log(this);
// let fisrtImg = document.querySelector(".image-inner");
//       // test

//       themeImages.innerHTML = "";
//       var index = 1;
//       var tabindex = 0;
      // images.forEach((element) => {
      //   let imageGid = element.node.previewImage.id;
      //   let imageId = imageGid.replace("gid://shopify/ImageSource/", "");
      //   let src = element.node.previewImage.src;

      //   var themeImage = document.createElement("div");
      //   themeImage.classList.add(
      //     "image__first",
      //     // "theme-img",
      //     // "theme-img-" + index,
      //     // "swiper-slide"
      //   );
      //   // if (index == 1) {
      //   //   themeImage.classList.add("current-image");
      //   // }
      //   // themeImage.setAttribute("data-full-size", src);
      //   var productMedia = document.createElement("div");
      //   productMedia.classList.add(
      //     // "product-media",
      //     // "product-media--image",
      //     // "product-media--activated"
      //     "rimage-outer-wrapper"
      //   );
      //   // productMedia.setAttribute("data-media-id", imageId);
      //   // themeImage.append(productMedia);

      //   var rimageWrapper = document.createElement("div");
      //   rimageWrapper.classList.add("rimage-wrapper");
      //   // rimageWrapper.style.paddingTop = "125.0%";
      //   productMedia.append(rimageWrapper);

      //   var img = document.createElement("img");
      //   img.classList.add("rimage__image", "fade-in");
      //   // setTimeout(() => {
      //   //   img.classList.add("ofade-animated");
      //   // }, 220);
      //   img.setAttribute("data-aspectratio", "1.0");
      //   img.setAttribute("srcset", src);
      //   rimageWrapper.append(img);

      //   themeImages.append(themeImage);
      //   //thumbs
      //   var thumb = document.createElement("div");
      //   thumb.classList.add(
      //     "product-area__details__thumbs__thumb",
      //     "product-area__details__thumbs__thumb-" + index,
      //     "theme-gallery-thumb",
      //     "slick-slide",
      //     "slick-current",
      //     "slick-active"
      //   );
      //   thumb.setAttribute("data-media-id", imageId);

      //   var thumbA = document.createElement("a");
      //   thumbA.href = "src";
      //   thumbA.classList.add("thumb-active", "ofade-in");
      //   setTimeout(() => {
      //     thumbA.classList.add("ofade-animated");
      //   }, 220);
      //   thumbA.setAttribute("tabindex", tabindex);
      //   thumb.append(thumbA);

      //   var rimageOuterWrapper = document.createElement("div");
      //   rimageOuterWrapper.classList.add("rimage-outer-wrapper");
      //   rimageOuterWrapper.style.maxWidth = "1080px";
      //   thumbA.append(rimageOuterWrapper);

      //   var rimageWrapperThumbs = document.createElement("div");
      //   rimageWrapperThumbs.classList.add("rimage-wrapper");
      //   rimageWrapperThumbs.style.paddingTop = "125.0%";
      //   rimageOuterWrapper.append(rimageWrapperThumbs);

      //   var imgThumbs = document.createElement("img");
      //   imgThumbs.classList.add("rimage__image");
      //   imgThumbs.setAttribute("data-aspectratio", "0.8");
      //   imgThumbs.setAttribute("srcset", src);
      //   rimageWrapperThumbs.append(imgThumbs);

      //   if (slickTrack) {
      //     slickTrack.append(thumb);
      //     slickList.style.height = "300px";
      //   }

      //   $(window).trigger("resize");

      //   index++;
      //   tabindex++;
      // });
    },

    toggleActive: function (elements, activeElement) {
      elements.forEach((element) => {
        element.classList.remove("active");
      });
      activeElement.classList.add("active");
    },

    changeElColors: function (color) {
      if (color == null) {
        return;
      }

      var logo = document
        .getElementById("davisactive-logo")
        ?.querySelector("path");
      logo?.setAttribute("fill", color);

      var announcement = document.querySelector(".cc-announcement");
      if (announcement) {
        var announcementMessage = document.querySelector(
          ".cc-announcement__inner"
        );
        announcement.style.backgroundColor = color;
        if (color == "#f1f0ec") {
          announcementMessage.style.color = "#000";
        } else {
          announcementMessage.style.color = "#fff";
        }
      }

      var addToCart = document.querySelector(".buyItNowButton");
      if (addToCart) {
        addToCart.style.backgroundColor = color;
        addToCart.style.borderColor = color;
        addToCart.style.color = "#faf9f6";
        if (color == "#f1f0ec") {
          addToCart.style.color = "#000";
        } else {
          addToCart.style.color = "#fff";
        }
      }
    },
  };
  productSwitcher.init();
})
  

};